import { render, staticRenderFns } from "./newList.vue?vue&type=template&id=3641c72f&scoped=true&"
import script from "./newList.vue?vue&type=script&lang=js&"
export * from "./newList.vue?vue&type=script&lang=js&"
import style0 from "./newList.vue?vue&type=style&index=0&id=3641c72f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641c72f",
  null
  
)

export default component.exports